import React, { useEffect } from 'react';
import { SiteSettings } from '../types';

interface AdSenseScriptProps {
    settings: SiteSettings;
    currentPath?: string;
}

const AdSenseScript: React.FC<AdSenseScriptProps> = ({ settings, currentPath }) => {
    useEffect(() => {
        if (!settings.enableAdSense || !settings.adSenseClientId) return;

        let scriptTimer: any;

        const cleanAdSenseDOM = () => {
             try {
                 // 1. Remove Google Auto Ads iframes and any dynamically injected aswift frames
                 document.querySelectorAll('iframe[id^="aswift_"], iframe[name^="google_ads"]').forEach(el => el.remove());
                 
                 // 2. Remove Google Auto placed ad wrappers
                 document.querySelectorAll('.google-auto-placed, [class*="google-auto-placed"], [id*="google-auto-placed"]').forEach(el => el.remove());
                 
                 // 3. Remove Google Vignette / Anchor containers appended to body or html
                 document.querySelectorAll('body > ins.adsbygoogle, html > ins.adsbygoogle').forEach(el => el.remove());

                 // 4. Reset inline padding and styles injected on body or html by Google AdSense
                 document.body.style.removeProperty('padding-top');
                 document.body.style.removeProperty('padding-bottom');
                 document.body.style.removeProperty('margin-top');
                 document.body.style.removeProperty('margin-bottom');
                 document.body.classList.remove('google-vignette-active');
                 
                 document.documentElement.style.removeProperty('padding-top');
                 document.documentElement.style.removeProperty('padding-bottom');

                 // 5. Remove style tags created by AdSense
                 document.querySelectorAll('style[data-espv]').forEach(el => el.remove());

                 // 6. Delete old script tags
                 document.querySelectorAll('script[src*="adsbygoogle.js"]').forEach(el => el.remove());

                 // 7. Reset the global adsbygoogle queue
                 (window as any).adsbygoogle = [];
             } catch (e) {
                 console.error('AdSense cleanup error:', e);
             }
        };

        const loadAds = () => {
             // Clean previous elements first
             cleanAdSenseDOM();
             
             // Wait 350ms to ensure React DOM rendering is fully settled before launching the new AdSense script
             scriptTimer = setTimeout(() => {
                 try {
                     const script = document.createElement('script');
                     script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${settings.adSenseClientId}`;
                     script.async = true;
                     script.crossOrigin = "anonymous";
                     document.head.appendChild(script);
                 } catch (e) {
                     console.error('Error injecting AdSense script:', e);
                 }
             }, 350);
        };

        loadAds();

        return () => {
            clearTimeout(scriptTimer);
        };
    }, [settings.enableAdSense, settings.adSenseClientId, currentPath]);

    return null;
};

export default AdSenseScript;
